import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommonApiService } from '../services/common-api.service';
import { environment } from '../../../environments/environment';

export const authenticateGuard: CanActivateFn = (route, state) => {
  const authService = inject(CommonApiService);
  const router = inject(Router);

  // Check login
  if (!authService.isLoggedIn()) {
    window.location.href = environment.blazzerUrl + '/account/login';
    return false;
  }

  //Get user from localStorage
  const userData = localStorage.getItem('sp-user');

  if (userData) {
    try {
      const user = JSON.parse(userData);

      //Check business account for /advance route
      if (state.url.startsWith('/advance')) {
        if (user.isBusinessAccount === true) {
          return true; //allow
        } else {
          localStorage.clear();
          sessionStorage.clear();

          window.location.href = environment.blazzerUrl + '/account/login';
          return false;
        }
      }

      // Other routes → allow
      return true;

    } catch (error) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = environment.blazzerUrl + '/account/login';
      return false;
    }
  }

  //No user data
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = environment.blazzerUrl + '/account/login';
  return false;
};